import { Link } from "gatsby"
import React from "react"
import FirebaseAuth from '../../../config/firebase'
import RightArrowSvg from "../../../images/svg/right-arrow.svg"
import LeftSideComponent from '../LeftSideComponent/LeftSideComponent'
import RightSideComponent from "../RightSideComponent/RightSideComponent"
import GoogleSvg from '../../../images/svg/google.svg'
import FBSvg from '../../../images/svg/fb.svg'
import Form from "./Form"
import SocialButton from './SocialButton/SocialButton'
import styles from './login.module.scss'

export default _ => {
  return (
    <div className={styles.container}>
      <LeftSideComponent>
        <div className={styles.inner}>
          <h2>Log in</h2>
          <div className={styles.form}>
            <Form />
          </div>
          <div className={styles.altLogin}>
            Or sign in with
            <div className={styles.socialLogin}>
              <SocialButton icon={<GoogleSvg />} text={'Sign in with Google'} onClick={FirebaseAuth.loginWithGoogle} />
              {/* <div onClick={FirebaseAuth.loginWithGoogle}>
                <GmailSvg />
              </div> */}
              {/* <div>
                <FBSvg />
              </div> */}
            </div>
          </div>
          <div className={styles.register}>
            Don't have an account?
            <Link to={'/register'}><span>Sign up here </span><RightArrowSvg /></Link>
          </div>
        </div>
      </LeftSideComponent>
      <RightSideComponent />
    </div>
  )
}